<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          <tg-dropdown :items="dropdown" @on-change="handleChange" trigger="click">
            <template slot="icon">
              <i class="tg-icon tg-icon-save"></i>
            </template>
          </tg-dropdown>
          <tg-date-search ref="dateSearch" size="small" v-model="dateRange"></tg-date-search>
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
        </tg-search-tool>
        <el-row type="flex" v-show="hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleExport"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.export") }}
          </tg-button>
        </el-row>
      </el-row>
      <tg-amount-bar ref="amount" v-if="showAmount" :columns="amountColumns" :row="amountData"></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      :filterMethods="filterMethods"
      @on-loaded="handleLoaded"
      @filter-change="remoteFilter"
      :summary-method="parsePageSummary"
      showSummary
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>

      <template slot="saveBy" slot-scope="scope">
        <tg-saveby-icon v-bind="scope" :types="saveby_type_icons"></tg-saveby-icon>
      </template>

      <template slot="step" slot-scope="scope">{{$t('component.dropdown.step[' +scope.value+ ']')}}</template>
      <template
        slot="action"
        slot-scope="scope"
      >{{$t('component.dropdown.finance[' + scope.value + ']')}}</template>

      <template slot="note" slot-scope="scope">
        <template v-if="scope.value">
          <span>{{ scope.value }}</span>
        </template>
        <template v-if="scope.row.gift_code">
          <template v-if="scope.value"><br></template>
          <span>{{ $t('column.tip') }}</span>
          <template v-if="scope.row.gift_code > 0">
            <span> - {{ $t('enum.tip_gift_' + scope.row.gift_code) }}</span>
          </template>
        </template>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgButton from "@/components/button/TgButton";
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgSavebyIcon from "@/components/slot/TgSavebyIcon";
import { convertToRows, flatColumns } from "@/utils/table";
import { summary } from "@/utils/table";
import xlsx from "@/utils/xlsx";

import apis from "@/apis";
const api = apis.accounts.finance;

export default {
  components: {
    TgButton,
    TgLayout,
    TgSearchTool,
    TgDropdown,
    TgDateSearch,
    TgAmountBar,
    TgTable,
    TgUserFullName,
    TgSavebyIcon,
  },
  data() {
    return {
      columns: [],
      exportColumns:[],
      proxy: api.getData,
      amountData: {},
      amountPageData: {},
      amountColumns: [],
      showAmount: false,
      dateRange: {},
      searchData: {
        targetName: "",
        type: 1,
        saveBy: null,
        note: null,
        step: null,
      },
      dropdown: [],
      // 存提款
      selected: null,
      filterMethods: {
        saveBy: this.handleFilter,
        note: this.handleFilter,
        step: this.handleFilter,
      },
      rechargeFilters: [],
      withdrawalFilters: [],
      hasData: false,
      saveBy: 1,
    };
  },
  computed: {
    headerHeight() {
      return !this.showAmount ? 80 : 140;
    },
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    stepFilter() {
      return [1, 2, 3, 4, 5].map((item) => {
        return {
          text: this.$t("component.dropdown.step[" + item + "]"),
          value: item,
        };
      });
    },
    saveby_type_icons() {
      let arr = this.rechargeFilters.concat(this.withdrawalFilters);

      return arr.reduce((a, c) => {
        a[c.id] = c.icon;
        return a;
      }, {})
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          0
        );
      };
    },
    dateString() {
      return new Date().toISOString().replace(/[-:.]/g, "");
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.rechargeFilters = response.data.rechargeFilters;
      this.withdrawalFilters = response.data.withdrawalFilters;

      let columns = response.data.columns.filter((x) => {
        return x.isExport == null;
      });
      this.exportColumns = response.data.columns;
      let saveByFilter = columns.findIndex(x => x.name == 'saveBy');
      columns[saveByFilter].filters = response.data.rechargeFilters;
      columns[saveByFilter]["filter-multiple"] = true;

      let noteFilter = columns.findIndex(x => x.name == 'note');
      columns[noteFilter].filters = [];
      columns[noteFilter]["filter-multiple"] = false;

      let stepFilter = columns.findIndex(x => x.name == 'step');
      columns[stepFilter].filters = this.stepFilter;
      columns[stepFilter]["filter-multiple"] = false;
      this.columns = columns;
      
      this.amountColumns = response.data.amountColumns;
      this.dropdown = this.parseDropdown(response.data.dropdown);
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  methods: {
    handleSearch() {
      this.$refs.table.search(this.request);
    },
    handleChange(item) {
      this.selected = item;
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.hasData = response.data.length > 0;
        this.showAmount =
          !("length" in response.amount_data) && response.data.length > 0;

        this.amountPageData = response.amountPageData;
        this.amountData = response.amount_data;
        let columns = JSON.parse(JSON.stringify(this.columns));

        let saveByFilter = columns.findIndex(x => x.name == 'saveBy');
        if(this.selected != null){          
          columns[saveByFilter].filters = this.selected.value == 1 ? this.rechargeFilters : this.withdrawalFilters;
          columns[saveByFilter]["filter-multiple"] = true;
        }

        let noteFilter = columns.findIndex(x => x.name == 'note');
        if(response.note_available.length > 0){
          columns[noteFilter].filters = response.note_available.map((item) => {
            return {
              text: item.text,
              value: item.keys,
            };
          });
        }
        columns[noteFilter]["filter-multiple"] = false;

        this.columns = columns;
      }
    },
    parseDropdown(dropdown) {
      return dropdown.map((item) => {
        return {
          label: this.$t("component.dropdown.finance[" + item + "]"),
          value: item,
        };
      });
    },
    handleFilter() {
      return true;
    },
    remoteFilter(filters) {
      for (let k in filters) {
        let filter = filters[k][0];
        if (k == 'saveBy') {
          filter = filters[k];
        }
        this.searchData[k] = filter;
      }

      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    handleExport() {
      api.getData({ ...this.request, isExport: true }).then((response) => {
        if (response.retcode == 0) {
          let { data, amount_data } = response;
          let headerRow = convertToRows(this.exportColumns);
          let columns = flatColumns(this.exportColumns);
          let ws = xlsx.makeSheet(headerRow, columns, data, amount_data);
          // xlsx.exportExcel(ws, "会员历史报表-" + this.dateString);
          xlsx.exportExcel(ws, this.$t("component.export.account_finance") + "-" + this.dateString);
        }
      });
    },
  },
  watch: {
    selected(val) {
      this.searchData.type = val.value;
    },
  },
};
</script>